import { getCookie } from '../utils/CookiesUtil';
import api from "./apiMethods";

const { REACT_APP_API_URL } = process.env;

export const getZones = async () => {
  const request = {
    method: "GET",
    url: `${REACT_APP_API_URL}/admin/get-zones`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);
};

